import { API_ENDPOINTS, apiRequest, Color, timeAsSeconds } from "@alba-cars/common-modules";

export const getAllColors = async (language?: "en" | "ar" | "ru" | "zh", onlyInStock?: boolean) => {
  let endpoint = API_ENDPOINTS.colors.list.toString();

  const params: string[] = [];

  if (language) {
    params.push(`language=${language}`);
  }

  if (onlyInStock) {
    params.push("onlyInStock=true");
  }

  if (params.length > 0) {
    endpoint = `${endpoint}?${params.join("&")}`;
  }

  const response = await apiRequest<{
    colors: (Color & { hexCode: string })[];
    total: number;
  }>(endpoint, {
    next: {
      tags: ["colors"],
      revalidate: timeAsSeconds({ minutes: 30 }),
    },
  });

  return response.colors;
};
